var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-content card--interactive text-center w-1/6"},[_c('div',{staticClass:"flex-item"},[_c('h4',{staticClass:"text-blue uppercase -mt-2 mb-4",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('h2',{staticClass:"mb-4",domProps:{"textContent":_vm._s(_vm.count)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }